import { ICalendarEvent, ICandidate, IOutlookCalendarEvent } from 'wisestep-api';

export const formDefaultValue = (candidate: ICandidate | null) => {
  return {
    title: candidate ? `Call with ${candidate.name}` : '',
    from: new Date(),
    to: new Date(new Date().getTime() + 30 * 60000),
    guest: [],
    reminder: 10,
    reminderIn: 'Minutes',
  };
};

export const formDefaultValueWhileEdit = (
  event: IOutlookCalendarEvent | ICalendarEvent | undefined
) => ({
  title: event?.eventSummary,
  from: new Date(event?.from ?? ''),
  to: new Date(event?.to ?? ''),
  guest: event?.attendees && event?.attendees.map((attendee) => attendee),
  reminder: 10,
  reminderIn: 'Minutes',
  eventId: event?.eventId,
  description: event?.eventDescription,
  location: event?.location,
  entityType: event?.entityType,
});
